import { Modal } from '@/components/molecule/Modal';
import { useMixpanel } from '@/hooks/mixpanel/mixpanel';
import { useTranslation } from '@/hooks/support/translate';
import { useWallet } from '@/hooks/wallet';
import { getNetworkByChainId } from '@/utils/utils';
import { ArrowUpCircled } from 'iconoir-react';
import { FC } from 'react';
import { Button } from '../atom/Button';

interface TransactionModalProps {
    visible: boolean;
    txHash: string;
    onClose: () => void;
}

export const TransactionModal: FC<TransactionModalProps> = (props) => {
    const { t } = useTranslation();
    const { track } = useMixpanel();
    const { walletState } = useWallet();
    const network = getNetworkByChainId(walletState.chainId);
    return (
        <Modal
            isVisible={props.visible}
            onClose={props.onClose}
            body={
                <div className="flex flex-col items-center">
                    <ArrowUpCircled
                        height={120}
                        width={120}
                        strokeWidth={0.5}
                        className="mt-12 mb-6 text-main-30"
                        fr="true"
                    />
                    <div className="mb-2 t__subtitle--s1">{t('modal.transaction.title')}</div>
                    <a
                        href={`${network?.explorer}${props.txHash}`}
                        className="t__button--u2 mb-9 text-main-30 hover:text-main-20"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => {
                            track('TRANSACTION-MODAL-VIEW-EXPLORER');
                        }}
                    >
                        {t('modal.transaction.viewTxn')}
                    </a>
                    <Button
                        name={t('modal.transaction.close')}
                        size="block"
                        onClick={() => {
                            props.onClose();
                            track('TRANSACTION-MODAL-CLOSE-BUTTON');
                        }}
                    >
                        {t('modal.transaction.close')}
                    </Button>
                </div>
            }
        />
    );
};
